import { IShift, ShiftProviderUser } from 'models';
import { ILeanShift } from '../../BusinessJob/models';
import React, { useState } from 'react';
import { TextButton } from 'library';
import { EventBusy } from '@mui/icons-material';
import CancelModal from './CancelModal';

interface CancelShiftModalTriggerProps {
    provider: ShiftProviderUser;
    shift: IShift | ILeanShift;
    refresh: () => void;
    textStyle?: React.CSSProperties;
    buttonStyle?: React.CSSProperties;
}

const CancelShiftModalTrigger = ({
    provider,
    shift,
    refresh,
    textStyle,
    buttonStyle,
}: CancelShiftModalTriggerProps) => {
    const [cancelOpen, setCancelOpen] = useState(false);

    return (
        <>
            <TextButton onClick={() => setCancelOpen(true)} textStyle={textStyle} buttonStyle={buttonStyle}>
                <EventBusy /> Cancel this shift
            </TextButton>
            <CancelModal
                open={cancelOpen}
                close={() => setCancelOpen(false)}
                shift={shift}
                providerName={provider?.first_name}
                refresh={refresh}
            />
        </>
    );
};

export default CancelShiftModalTrigger;
